import { render, staticRenderFns } from "./tab-component-render.vue?vue&type=template&id=1bf9dd9f"
import script from "./tab-component-render.vue?vue&type=script&lang=js"
export * from "./tab-component-render.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports